<template>
    <base-card>
    <h1>Url not found. Please <router-link to="/login">click</router-link> to continue</h1>
    </base-card>
</template>